module.exports = __webpack_public_path__ + "static/media/longLeaf.323d41c0.png";